import React, { useState } from 'react';

const BRAND = '#0f6e56';

export default function Contact({ onBack }) {
  const [form, setForm] = useState({ name:'', email:'', phone:'', message:'' });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = `mailto:info@finlybooks.com?subject=Contact from ${form.name}&body=${form.message}%0A%0AFrom: ${form.name}%0AEmail: ${form.email}%0APhone: ${form.phone}`;
    setSent(true);
  };

  return (
    <div style={{ minHeight:'100vh', background:'#f7f8fa' }}>
      <div style={{ background:BRAND, padding:'0 32px', height:64, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div style={{ color:'#fff', fontSize:20, fontWeight:700 }}>FinlyBooks</div>
        <button onClick={onBack} style={{ background:'rgba(255,255,255,0.15)', border:'none', color:'#fff', padding:'7px 16px', borderRadius:8, cursor:'pointer', fontSize:13 }}>← Back to app</button>
      </div>

      <div style={{ maxWidth:1000, margin:'0 auto', padding:'48px 24px' }}>
        <div style={{ textAlign:'center', marginBottom:48 }}>
          <div style={{ fontSize:36, fontWeight:700, color:'#222', marginBottom:10 }}>Get in touch</div>
          <div style={{ fontSize:16, color:'#666', maxWidth:500, margin:'0 auto' }}>Have a question about FinlyBooks? We're here to help. Reach out and we'll get back to you within 24 hours.</div>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:40 }}>
          <div>
            <div style={{ background:'#fff', borderRadius:16, padding:32, border:'1px solid #e8e8e8', marginBottom:20 }}>
              <div style={{ fontSize:18, fontWeight:700, color:'#222', marginBottom:24 }}>Contact information</div>

              <ContactItem icon="📧" label="Email" value="info@finlybooks.com" href="mailto:info@finlybooks.com" />
              <ContactItem icon="🌐" label="Website" value="www.finlybooks.com" href="https://www.finlybooks.com" />
              <ContactItem icon="📱" label="WhatsApp" value="+91 99041 56467" href="https://wa.me/919904156467" />
            </div>

            <div style={{ background:`linear-gradient(135deg, ${BRAND}, #1d9e75)`, borderRadius:16, padding:32, color:'#fff' }}>
              <div style={{ fontSize:22, fontWeight:700, marginBottom:8 }}>FinlyBooks</div>
              <div style={{ fontSize:14, opacity:0.85, letterSpacing:0.5, marginBottom:16 }}>Track. Manage. Grow.</div>
              <div style={{ fontSize:13, opacity:0.75, lineHeight:1.8 }}>
                Free accounting software for small businesses and beginners. Manage invoices, track expenses, and understand your finances — all in one place.
              </div>
              <div style={{ marginTop:20, paddingTop:16, borderTop:'1px solid rgba(255,255,255,0.2)', fontSize:12, opacity:0.6 }}>
                © 2025 FinlyBooks. All rights reserved.
              </div>
            </div>
          </div>

          <div style={{ background:'#fff', borderRadius:16, padding:32, border:'1px solid #e8e8e8' }}>
            <div style={{ fontSize:18, fontWeight:700, color:'#222', marginBottom:24 }}>Send us a message</div>
            {sent ? (
              <div style={{ textAlign:'center', padding:'40px 0' }}>
                <div style={{ fontSize:48, marginBottom:16 }}>✅</div>
                <div style={{ fontSize:18, fontWeight:600, color:BRAND, marginBottom:8 }}>Message sent!</div>
                <div style={{ fontSize:14, color:'#888' }}>We'll get back to you at {form.email} within 24 hours.</div>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <FField label="Your name *" value={form.name} onChange={v => setForm(f=>({...f,name:v}))} placeholder="e.g. John Smith" />
                <FField label="Email address *" type="email" value={form.email} onChange={v => setForm(f=>({...f,email:v}))} placeholder="you@example.com" />
                <FField label="Phone number" value={form.phone} onChange={v => setForm(f=>({...f,phone:v}))} placeholder="+1 555 000 0000" />
                <div style={{ marginBottom:20 }}>
                  <label style={labelStyle}>Message *</label>
                  <textarea value={form.message} onChange={e => setForm(f=>({...f,message:e.target.value}))}
                    placeholder="How can we help you?" required rows={5}
                    style={{ width:'100%', padding:'10px 14px', border:'1px solid #ddd', borderRadius:10, fontSize:14, color:'#222', outline:'none', resize:'vertical', fontFamily:'inherit' }} />
                </div>
                <button type="submit" style={{ width:'100%', padding:14, background:BRAND, color:'#fff', border:'none', borderRadius:10, fontSize:15, fontWeight:700, cursor:'pointer' }}>
                  Send message →
                </button>
                <div style={{ textAlign:'center', marginTop:12, fontSize:12, color:'#aaa' }}>
                  Or email us directly at{' '}
                  <a href="mailto:info@finlybooks.com" style={{ color:BRAND, fontWeight:500 }}>info@finlybooks.com</a>
                </div>
              </form>
            )}
          </div>
        </div>

        <div style={{ marginTop:48, background:'#fff', borderRadius:16, padding:32, border:'1px solid #e8e8e8' }}>
          <div style={{ fontSize:18, fontWeight:700, color:'#222', marginBottom:20, textAlign:'center' }}>Why choose FinlyBooks?</div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(200px, 1fr))', gap:20 }}>
            {[
              { icon:'🆓', title:'100% Free', desc:'No hidden fees. Use all features completely free.' },
              { icon:'📊', title:'Full accounting', desc:'Invoices, expenses, P&L, Balance Sheet and more.' },
              { icon:'📱', title:'Mobile + Web', desc:'Works on Android, iOS and any web browser.' },
              { icon:'🔒', title:'Secure', desc:'Your data is protected with Firebase security.' },
            ].map(f => (
              <div key={f.title} style={{ textAlign:'center', padding:20 }}>
                <div style={{ fontSize:32, marginBottom:12 }}>{f.icon}</div>
                <div style={{ fontSize:15, fontWeight:600, color:'#222', marginBottom:6 }}>{f.title}</div>
                <div style={{ fontSize:13, color:'#888', lineHeight:1.6 }}>{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function ContactItem({ icon, label, value, href }) {
  return (
    <a href={href} target="_blank" rel="noreferrer" style={{ display:'flex', alignItems:'center', gap:14, padding:'14px 0', borderBottom:'1px solid #f0f0f0', textDecoration:'none' }}>
      <div style={{ width:44, height:44, borderRadius:12, background:'#e1f5ee', display:'flex', alignItems:'center', justifyContent:'center', fontSize:20, flexShrink:0 }}>{icon}</div>
      <div>
        <div style={{ fontSize:12, color:'#888', marginBottom:2 }}>{label}</div>
        <div style={{ fontSize:14, fontWeight:500, color:BRAND }}>{value}</div>
      </div>
    </a>
  );
}

function FField({ label, type='text', value, onChange, placeholder }) {
  return (
    <div style={{ marginBottom:16 }}>
      <label style={labelStyle}>{label}</label>
      <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} required={label.includes('*')}
        style={{ width:'100%', padding:'10px 14px', border:'1px solid #ddd', borderRadius:10, fontSize:14, color:'#222', outline:'none' }} />
    </div>
  );
}

const labelStyle = { display:'block', fontSize:13, fontWeight:500, color:'#555', marginBottom:6 };
